/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ServiceAddressCreate = {
    properties: {
        districtId: {
            type: 'string',
            isRequired: true,
            format: 'uuid',
        },
        type: {
            type: 'ServiceAddressTypeEnum',
        },
        street: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        city: {
            type: 'string',
            isRequired: true,
            minLength: 1,
        },
        state: {
            type: 'string',
            isRequired: true,
            maxLength: 2,
            minLength: 2,
        },
        zip: {
            type: 'string',
            isRequired: true,
            maxLength: 10,
            minLength: 5,
        },
        zip4: {
            type: 'string',
            isNullable: true,
            maxLength: 4,
            minLength: 4,
        },
    },
};